import CampanhaService from './CampanhaService'
export default class TemaService {

    

    constructor(campanha) {
        if (campanha && campanha.styles) {
            this.styles = campanha.styles
        } else {
            this.styles = []
        }
    }

    getStyle(pagina) {
        if (! pagina) {
            return null
        }
        if (this.styles && this.styles.length > 0) {
            for (var i = 0; i < this.styles.length; i++) {
                if (this.styles[i].page === pagina) {
                    return this.styles[i]
                }
            }
        } 
        return null
    }

    aplicarTema(pagina) {
        let tema = this.getStyle(pagina)
        if (tema) {
            var element = document.querySelector(".weex")
            if (tema.backgroundImage) {
                console.log("entrei aqui bg image")
                if (element) {
                    element.style.backgroundImage = "url(" + tema.backgroundImage + ")";
                    element.style.backgroundSize = "100% auto";
                    element.style.backgroundRepeat = 'no-repeat';
                    if(tema.backgroundColor) {
                        element.style.backgroundColor = tema.backgroundColor
                    }
                }
            } else if (!tema.backgroundImage && tema.backgroundColor) {
                if (element) {
                    element.style.background = tema.backgroundColor
                }
            }
            var primeiroPlano = document.querySelectorAll(".foreground")
            if (primeiroPlano) {
                for (var i = 0; i < primeiroPlano.length; i++) {
                    primeiroPlano[i].style.color = tema.foregroundColor
                }
            }
        }
    }

}